import { FollowAPI } from './lib/follow-api'

export default new FollowAPI();
 
